export default "__VITE_ASSET__A7DMJ_ru__"